var _a, _b;
export var FULLSCREEN = {
    ALLOW_TITLE: 'controllers_fullscreen_allowTitleExpand',
    ALLOW_DESCRIPTION: 'controllers_fullscreen_allowDescriptionExpand',
    ALLOW_LINK: 'controllers_fullscreen_allowLinkExpand',
    WHEN_TO_SHOW_INFO: 'controllers_fullscreen_whenToShowInfo',
    EXPAND_INFO_POSITION: 'controllers_fullscreen_expandInfoPosition',
    SHOW_INFO_BUTTON: 'controllers_fullscreen_showInfoExpandButton',
    ALLOW_FULLSCREEN_EXPAND: 'controllers_fullscreen_allowFullscreenExpand',
    LOOP: 'controllers_fullscreen_fullscreenLoop',
    ALLOW_MAGNIFY_IMAGE: 'controllers_fullscreen_allowFullscreenMagnifyImage',
    MAGNIFICATION_LEVEL: 'controllers_fullscreen_fullscreenMagnificationLevel',
    BACKGROUND_BLUR_FILTER: 'controllers_fullscreen_backgroundBlurFilter',
    BACKGROUND_GRAYSCAL_EFILTER: 'controllers_fullscreen_backgroundGrayscaleFilter',
    FULLSCREEN_PREVIEW: 'FULLSCREEN_PREVIEW',
};
export var FULLSCREEN_CONTROLLERS = (_a = {},
    _a[FULLSCREEN.WHEN_TO_SHOW_INFO] = function (value) {
        var _a;
        var shouldToggleInfo = value === 'ON_TOGGLE';
        return _a = {},
            _a[FULLSCREEN.SHOW_INFO_BUTTON] = shouldToggleInfo,
            _a.defaultShowInfoExpand = !shouldToggleInfo,
            _a;
    },
    _a);
export var FULLSCREEN_CONTROLLERS_DATA = (_b = {},
    _b[FULLSCREEN.ALLOW_TITLE] = {
        key: FULLSCREEN.ALLOW_TITLE,
        title: 'Native_ProGallery_Expand_InfoSettings_WhatInfo_Title',
        description: 'MISSING_Allow title',
        type: 'BOOLEAN',
        default: true,
    },
    _b[FULLSCREEN.ALLOW_DESCRIPTION] = {
        key: FULLSCREEN.ALLOW_DESCRIPTION,
        title: 'Native_ProGallery_Expand_InfoSettings_WhatInfo_Description',
        description: 'MISSING_Allow description',
        type: 'BOOLEAN',
        default: true,
    },
    _b[FULLSCREEN.ALLOW_LINK] = {
        key: FULLSCREEN.ALLOW_LINK,
        title: 'Native_ProGallery_Expand_InfoSettings_WhatInfo_Link',
        description: 'MISSING_Native_ProGallery_Layout_LoadMoreBtn_Toggle_Description',
        type: 'BOOLEAN',
        default: false,
    },
    _b[FULLSCREEN.WHEN_TO_SHOW_INFO] = {
        key: FULLSCREEN.WHEN_TO_SHOW_INFO,
        title: "Native_ProGallery_Expand_InfoSettings_WhenInfo_Label",
        type: "OPTIONS",
        controller: "RADIO",
        thumbnailsSize: "MEDIUM",
        default: "ALWAYS",
        options: [
            {
                value: "ALWAYS",
                title: "Native_ProGallery_Expand_InfoSettings_WhenInfo_Always"
            },
            {
                value: "ON_TOGGLE",
                title: "Native_ProGallery_Expand_InfoSettings_WhenInfo_Icon"
            }
        ],
        description: "Native_ProGallery_Expand_InfoSettings_WhenInfo_Tooltip"
    },
    _b[FULLSCREEN.EXPAND_INFO_POSITION] = {
        key: FULLSCREEN.EXPAND_INFO_POSITION,
        title: 'Native_ProGallery_Expand_InfoSettings_WhereInfo_Label',
        type: 'OPTIONS',
        default: 'SIDE',
        options: [
            {
                value: 'BOTTOM',
                title: 'Native_ProGallery_Expand_InfoSettings_WhereInfo_Bottom',
            },
            {
                value: 'SIDE',
                title: 'Native_ProGallery_Expand_InfoSettings_WhereInfo_Side',
            },
        ],
        description: 'MISSING_Info position',
    },
    _b[FULLSCREEN.SHOW_INFO_BUTTON] = {
        key: FULLSCREEN.SHOW_INFO_BUTTON,
        title: 'MISSING_Toggle info',
        description: 'MISSING_Toggle info',
        type: 'BOOLEAN',
        default: false,
    },
    _b[FULLSCREEN.ALLOW_FULLSCREEN_EXPAND] = {
        key: FULLSCREEN.ALLOW_FULLSCREEN_EXPAND,
        title: 'Native_ProGallery_Expand_ViewingSettings_FullScreen',
        description: 'Native_ProGallery_Expand_ViewingSettings_FullScreen_Tooltip',
        type: 'BOOLEAN',
        default: true,
    },
    _b[FULLSCREEN.LOOP] = {
        key: FULLSCREEN.LOOP,
        title: 'Native_ProGallery_Expand_ViewingSettings_Loop',
        description: 'Native_ProGallery_Expand_ViewingSettings_Loop_Tooltip',
        type: 'BOOLEAN',
        default: false,
    },
    _b[FULLSCREEN.ALLOW_MAGNIFY_IMAGE] = {
        key: FULLSCREEN.ALLOW_MAGNIFY_IMAGE,
        title: 'Native_ProGallery_Expand_ViewingSettings_Magnifying',
        description: 'Native_ProGallery_Expand_ViewingSettings_Magnifying_Tooltip',
        type: 'BOOLEAN',
        default: false,
    },
    _b[FULLSCREEN.MAGNIFICATION_LEVEL] = {
        key: FULLSCREEN.MAGNIFICATION_LEVEL,
        title: 'Native_ProGallery_Expand_ViewingSettings_MagnifyingSize',
        description: 'MISSING_Magnification value',
        type: 'NUMBER',
        min: 1,
        max: 5,
        step: 1,
        default: 2,
    },
    _b[FULLSCREEN.BACKGROUND_BLUR_FILTER] = {
        key: FULLSCREEN.BACKGROUND_BLUR_FILTER,
        title: 'Native_ProGallery_Expand_BackgroundFilters_Blur',
        description: 'MISSING_Background blur filter',
        type: 'NUMBER',
        min: 1,
        max: 20,
        step: 1,
        default: 1,
    },
    _b[FULLSCREEN.BACKGROUND_GRAYSCAL_EFILTER] = {
        key: FULLSCREEN.BACKGROUND_GRAYSCAL_EFILTER,
        title: 'Native_ProGallery_Expand_BackgroundFilters_Grayscale',
        description: 'MISSING_Background Grayscale filter',
        type: 'BOOLEAN',
        default: false,
    },
    _b[FULLSCREEN.FULLSCREEN_PREVIEW] = {
        key: FULLSCREEN.FULLSCREEN_PREVIEW,
        title: 'Native_ProGallery_Expand_ExpandPreview_Header',
        type: 'VIEWPORT',
        default: '',
        component: 'FULLSCREEN',
    },
    _b);
//# sourceMappingURL=fullscreen.js.map